export function formatPrice(value, {exponent, symbol, format}){
	var s = value.toFixed(exponent);
	if (format === 'SYMBOL-PRICE'){
		return `${symbol}${s}`;
	}
	return `${s}${symbol}`;
}